var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 1.263L10.556 0H5L3.88904 1.263H0V3.789H15.556V1.263H11.666H11.667Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4339 20H12.1209C12.5172 19.9872 12.9022 19.8642 13.2325 19.6448C13.5628 19.4254 13.8254 19.1183 13.9909 18.758C14.1912 18.3597 14.2947 17.9198 14.2929 17.474V2.32001H1.26288V17.474C1.25919 18.0077 1.40846 18.5313 1.69294 18.983C1.87353 19.2858 2.12798 19.538 2.43244 19.7158C2.7369 19.8937 3.08141 19.9914 3.4339 20V20Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13.21L10.9601 6.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13.21L10.9601 6.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25L10.9601 13.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25L10.9601 13.21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.555,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.32afa6e26d95c463eb4d26f8a18ca689.svg";
export { ForwardRef as ReactComponent };